<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'general.select' | translate }}
  </div>
  @for (item of parentItems(); track item) {
  <div class="container">
    <ng-container [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ item }"></ng-container>
  </div>
  }
  <div class="ion-margin-top flex tw:flex">
    @if (multiple()) {
    <ion-button color="light"
      shape="round"
      (click)="save()">
      {{ 'general.select' | translate }}
    </ion-button>
    }
    @if (clearButton()) {
    <ion-button color="light"
      shape="round"
      (click)="clear()">
      <ion-icon slot="start"
        name="close-outline"></ion-icon>
      {{ 'general.clear' | translate }}
    </ion-button>
    }
  </div>
</app-main-dialog>
<ng-template #itemTemplate
  let-item="item">
  <ion-item button="true"
    lines="none"
    (click)="select(item)">
    @if (item.selected) {
    <ion-icon slot="start"
      name="checkmark-outline"></ion-icon>
    }
    {{ item.name }}
  </ion-item>
  @for (child of item.children; track child) {
  <div class="child">
    <ng-container [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ item: child }"></ng-container>
  </div>
  }
</ng-template>
